import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { DropdownItem } from '../../../viewmodels/dropdown-item';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class AutoCompleteControl extends FormControlBase<any> {
  controlType = 'autocomplete';

  allowUserEntry: boolean = true;
  allowBrowserAutocomplete: boolean = true;
  onBlur = new Subject();
  onChange = new Subject();

  constructor(options: FormControlData<any> = {}) {
    super(options);
  }

  protected initialize() {
    const val = _.get(this.model, this.propertyName);
    this.value = val ? val : this.defaultValue;
  }

  lostFocus() {
    this.onBlur.next();
  }

  valueChanged(value: any) {
    const retValue = new DropdownItem(value, undefined);
    if (!this.options) {
      return;
    }
    const chosenItem = _.find(this.options, it => it.label === value);
    if (chosenItem) {
      retValue.value = chosenItem.value;
    }
    this.onChange.next(retValue);
  }
}
